import { apiSlice } from "services/apiSlice";

export const roleApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRolesByCompany: builder.query({
      query: (companyId) => `roles/company/${companyId}`,
      providesTags: ["Roles"],
    }),
    createRole: builder.mutation({
      query: (data) => ({
        url: "roles",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Roles"], // utile si tu as une liste de rôles
    }),
    getRoles: builder.query({
      query: () => "roles",
      providesTags: ["Roles"],
    }),
    updateRole: builder.mutation({
      query: ({ id, data }) => ({
        url: `roles/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Roles"],
    }),
  }),
});

export const {
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useGetRolesQuery,
  useGetRolesByCompanyQuery,
} = roleApi;
